import { Badge } from '@mui/material';

const LessonCount = ({ lessons = [] }) => (
  <Badge badgeContent={lessons.length} color='primary' showZero />
);

export default LessonCount;
